import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ArticulosGeneral, EcommerceGenericoService, HistorialPedidos, MediosPagos } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { MenuMmaxInterface } from '../etc/mmax-menu.interface';
import { MarianomGeneral } from '../marianom-general.service';

@Component({
  selector: 'mmax-cierre-carro',
  templateUrl: './mmax-cierre-carro.component.html',
  styleUrls: ['./mmax-cierre-carro.component.scss']
})

export class MmaxCierreCarroComponent implements OnInit, OnDestroy {
  displayPreMedios: boolean = false;
  displayMedios: boolean = false;
  displayMP: boolean = false;
  displayPago: boolean = false;
  error: string;
  planesDePagoEnPantalla: PagosMMaxPlanes[] = [];
  mymedios: MediosPagos;
  myPlan: PagosMMaxPlanes;
  mercadoP: boolean = false;
  pagoDiferido: string;
  ruta: string;
  flagDeshabilitado: boolean = false;
  beneficiosTrue: boolean = false;
  saldoActual: number = 0;
  conSaldo: boolean = false;
  errorSaldo: boolean = false;
  cargandoPlanes: boolean = false;
  publicKeyMP: string;
  idcheckoutMercadoPago: string;
  private pollingInterval: any;
  private queryParamsSubscription: Subscription;
  isCerrando: boolean = false;
  constructor(private serv: MarianomGeneral, private genServ: EcommerceGenericoService, private router: ActivatedRoute) {
    this.genServ.getPagoDiferido().subscribe({
      next: pagoDiferido => {
        console.log('DEBUG: MmaxCierreCarroComponent -> Recibido pagoDiferido:', pagoDiferido);
        this.pagoDiferido = pagoDiferido;
        this.evaluarPagoDiferido();
      }
    })
    this.ruta = window.location.hash;
    this.genServ.returnBeneficios().subscribe({
      next: data => {
        if (data == 'S') {
          this.beneficiosTrue = true;
          this.genServ.getMovimientosMmax().subscribe({
            next: data => {
              this.saldoActual = data[0].saldo_real;
              this.conSaldo = true;
            },
            error: error => {
              this.errorSaldo = true;
              this.genServ.pendingFalse();
            }
          })
        }
      }
    })
  }

  evaluarPagoDiferido() {
    this.pagoDiferido = (this.pagoDiferido || '').toString().trim();
    console.log('DEBUG: MmaxCierreCarroComponent -> evaluando con pagoDiferido:', this.pagoDiferido);
    
    if (this.pagoDiferido === "S" || this.pagoDiferido === "E") {
      console.log('DEBUG: MmaxCierreCarroComponent -> Modo Diferido/Empresa ACTIVO');
      this.displayMedios = false;
      this.displayPreMedios = true;
      this.displayPago = false;
      this.displayMP = false;
    } else if (this.pagoDiferido === "N") {
      console.log('DEBUG: MmaxCierreCarroComponent -> Modo Obligatorio (N) ACTIVO');
      this.displayMedios = true;
      this.displayPreMedios = false;
    } else {
      console.log('DEBUG: MmaxCierreCarroComponent -> Estado pendiente o desconocido:', this.pagoDiferido);
    }
    
    console.log('DEBUG: MmaxCierreCarroComponent -> Flags: displayMedios=', this.displayMedios, 'displayPreMedios=', this.displayPreMedios);
  }

  ngOnInit(): void {
    console.log('DEBUG: MmaxCierreCarroComponent -> ngOnInit - valor actual pagoDiferido:', this.pagoDiferido);
    window.addEventListener("beforeunload", this.beforeUnload);
    this.deshabilitarBack();
    this.evaluarPagoDiferido();

    // Intentar recuperar el estado de pago de localStorage (por si hubo redirect)
    const savedMedio = localStorage.getItem('mp_last_medio');
    const savedPlan = localStorage.getItem('mp_last_plan');
    
    if (savedMedio && !this.mymedios) {
      try {
        this.mymedios = JSON.parse(savedMedio);
        console.log('DEBUG: MmaxCierreCarroComponent -> ngOnInit: Recuperado medio de pago de localStorage:', this.mymedios?.nombre, this.mymedios?.mediopago);
        
        // Si recuperamos medio y plan, y es MP, forzamos la vista de MP
        if (savedPlan) {
          this.myPlan = JSON.parse(savedPlan);
          console.log('DEBUG: MmaxCierreCarroComponent -> ngOnInit: Recuperado plan de pago de localStorage:', this.myPlan?.nombre, this.myPlan?.plan);
          
          if (this.mymedios?.nombre?.toLowerCase().includes('mercado pago') || this.myPlan?.idcheckout) {
              const idCheckout = this.myPlan?.idcheckout || '';
              console.log('DEBUG: MmaxCierreCarroComponent -> ngOnInit: Re-activando vista Mercado Pago con idCheckout:', idCheckout);
              this.activarMercadoPago(idCheckout);
          }
        }
      } catch (e) {
        console.error('DEBUG: MmaxCierreCarroComponent -> Error al parsear estado de pago de localStorage', e);
      }
    } else {
      console.log('DEBUG: MmaxCierreCarroComponent -> No se recuperó estado de pago de localStorage (o already set)');
    }

    // Siempre intentar cerrar el overlay por si quedó huérfano de una navegación anterior
    this.cerrarOverlayMP();
    this.detectarPagoExitoso();
  }

  ngOnDestroy(): void {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
    window.removeEventListener("beforeunload", this.beforeUnload);
  }

  detectarPagoExitoso() {
    console.log('DEBUG: MmaxCierreCarroComponent -> Suscribiendo a detectarPagoExitoso');
    this.queryParamsSubscription = this.router.queryParams.subscribe(params => {
      const status = params['status'] || params['collection_status'] || params['payment_status'];
      console.log('DEBUG: MmaxCierreCarroComponent -> Suscripción queryParams ACTIVADA:', params);
      
      if (status === 'approved' || status === 'authorized' || status === 'in_process' || status === 'pending') {
        console.log('DEBUG: MmaxCierreCarroComponent -> Estado de pago VÁLIDO detectado:', status);
        // Pequeño delay para asegurar que el resto del componente se estabilice tras la recuperación del localStorage
        setTimeout(() => {
          this.finalizarCompra();
        }, 800);
      } else if (status) {
        console.log('DEBUG: MmaxCierreCarroComponent -> Estado de pago detectado pero NO aprobado:', status);
      }
    });
  }

  private cerrarOverlayMP() {
    console.log('DEBUG: MmaxCierreCarroComponent -> Intentando cerrar overlay MP por fuerza bruta...');
    const overlay = document.querySelector('.mercadopago-checkout-p-container');
    if (overlay) {
      console.log('DEBUG: MmaxCierreCarroComponent -> Overlay encontrado, eliminando del DOM');
      overlay.remove();
    } else {
      console.log('DEBUG: MmaxCierreCarroComponent -> No se encontró overlay por clase .mercadopago-checkout-p-container');
    }
    // También limpiamos el contenedor original
    const container = document.getElementById('containerMP');
    if (container) {
      container.innerHTML = '';
    }
  }

  private finalizarCompra() {
    this.error = undefined;
    
    // Si no tenemos medio o plan (raro en MP pero posible si se refresca), intentamos recuperar de localStorage si aun no se hizo
    if (!this.mymedios || !this.myPlan) {
      console.warn('DEBUG: MmaxCierreCarroComponent -> finalizarCompra sin medio/plan. Navegando directamente.');
      this.cerrarOverlayMP();
      localStorage.removeItem('mp_last_medio');
      localStorage.removeItem('mp_last_plan');
      this.genServ.resetEccomerce();
      this.serv.navigator.endline(this.router);
      return;
    }

    console.log('DEBUG: MmaxCierreCarroComponent -> INICIANDO finalizarCompra', { 
      medio: this.mymedios?.nombre, 
      plan: this.myPlan?.nombre, 
      isCerrando: this.isCerrando,
      hasPedido: !!this.genServ.verUltimoPedido()
    });

    if (this.mymedios && this.myPlan && !this.isCerrando) {
      this.isCerrando = true;
      this.genServ.cerrarFinaleccomerce(this.mymedios.mediopago, this.myPlan.plan).subscribe({
        next: data => {
          console.log('DEBUG: MmaxCierreCarroComponent -> cerrarFinaleccomerce EXITOSO');
          this.cerrarOverlayMP();
          localStorage.removeItem('mp_last_medio');
          localStorage.removeItem('mp_last_plan');
          localStorage.removeItem('active_pedido');
          this.serv.navigator.endline(this.router);
          this.genServ.resetEccomerce();
        },
        error: err => {
          console.error('DEBUG: MmaxCierreCarroComponent -> Error en cerrarFinaleccomerce:', err);
          this.error = err['error'] ? err['error']['statussalida'] : 'Error al finalizar el pedido';
          this.isCerrando = false;
          this.cerrarOverlayMP();
        }
      });
    }
  }

  iniciarPollingPago() {
    if (this.pollingInterval) return;

    console.log('DEBUG: MmaxCierreCarroComponent -> Iniciando polling de pago...');
    this.pollingInterval = setInterval(() => {
      this.genServ.getHistorialDePedidos().subscribe({
        next: () => {
          const historial = this.genServ.obtenerHistorialDePedidosCargados();
          if (historial && historial.length > 0) {
            // Ordenamos por ID para tener el más reciente
            const ultimoPedido = this.genServ.ordenarporFechaHistorial(historial)[0];
            const status = this.genServ.getStatusDisplay(ultimoPedido).toLowerCase();
            
            console.log('DEBUG: MmaxCierreCarroComponent -> Polling status ultimo pedido:', status);
            
            if (status === 'pagado' || status === 'preparacion') {
              console.log('DEBUG: MmaxCierreCarroComponent -> Pedido PAGADO detectado por polling');
              this.detenerPollingPago();
              this.finalizarCompra();
            }
          }
        }
      });
    }, 5000); // Cada 5 segundos
  }

  detenerPollingPago() {
    if (this.pollingInterval) {
      console.log('DEBUG: MmaxCierreCarroComponent -> Deteniendo polling de pago.');
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  }

  manejarCierreMP() {
    console.log('DEBUG: MmaxCierreCarroComponent -> Cerrado modal MP sin confirmar pago.');
    this.cerrarOverlayMP(); // Fuerza bruta para limpiar cualquier rastro de MP
    this.displayMP = false;
    this.displayMedios = true;
    this.mercadoP = false;
    this.idcheckoutMercadoPago = undefined;
    this.detenerPollingPago();
    this.isCerrando = false; // Reset de flag de cierre para permitir reintento
    
    // Cerramos el spinner por seguridad
    this.genServ.modal.close('spinner-modal');
    
    // Restauramos el estado de selección pero SIN re-disparar el proceso de MP
    if (this.mymedios) {
      this.displayPago = true; // Mostramos los planes pero no el botón de MP automáticamente
    }
  }

  get mysmedios() {
    return this.genServ.devolverMediosPagos() || [];
  }

  get totales() {
    let montoTotal = this.genServ.getTotal();
    return montoTotal;
  }

  get costoEnvio() {
    return this.genServ.costoUltimoFlete;
  }

  get total() {
    let cantTotal = this.genServ.getCantidadTotal();
    const articulosEnCarrito: ArticulosGeneral[] = this.genServ.getCarrito();

    articulosEnCarrito.forEach(
      (articulo: ArticulosGeneral) => {
        if (articulo.getNombreMarca() == 'FLETES') {
          cantTotal = cantTotal + 1;
        }
      }
    );
    return cantTotal;
  }

  get articulosconcantidad() {
    return this.genServ.getCarrito();
  }

  get menus(): MenuMmaxInterface[] {
    return this.serv.rutas
  }

  beforeUnload(e) {
    var confirmationMessage = "LOL";
    e.returnValue = confirmationMessage;
    return confirmationMessage;
  }

  deshabilitarBack() {
    const self = this;
    window.onhashchange = function () {
      if (window.location.hash != "#/checkout/finalizar") {
        self.flagDeshabilitado = true;
        window.location.hash = "#/checkout/finalizar";
      }
      return self.flagDeshabilitado;
    }

    if (this.flagDeshabilitado === true) {
      this.serv.navigator.cierreCheckout(this.router);
    }
  }

  habilitarBack() {
    window.removeEventListener("beforeunload", this.beforeUnload);
  }

  volverAtras() {
    for (let i = 0; i < this.menus.length; i++) {
      const element = this.menus[i];
      element.activo = false;
    }
    this.genServ.resetEccomerce();
    localStorage.removeItem('active_pedido');
    localStorage.removeItem('mp_last_medio');
    localStorage.removeItem('mp_last_plan');
    this.serv.navigator.goLandPage(this.router);
    this.serv.cerrarUI();
  }

  cancelarCompra() {
    this.genServ.cancelarPedidoWeb();
    this.volverAtras();
  }

  siPagar() {
    console.log('DEBUG: MmaxCierreCarroComponent -> siPagar() clickeado');
    this.displayMedios = true;
    this.displayPreMedios = false;
  }

  noPagar() {
    console.log('DEBUG: MmaxCierreCarroComponent -> noPagar() clickeado');
    this.serv.navigator.endline(this.router);
    this.genServ.resetEccomerce();
  }

  activarMediodepago(medio: MediosPagos) {
    this.displayPago = true;
    this.displayMP = false;
    this.genServ.devolverMediosPagos().forEach(
      (medioDePago: MediosPagos) => {
        medioDePago.selecionado = false;
      }
    )
    this.mercadoP = false;
    medio.selecionado = true;
    this.mymedios = medio;
    localStorage.setItem('mp_last_medio', JSON.stringify(medio));
    //console.log('this.mymedios.mediopago', this.mymedios.mediopago)
    this.cargandoPlanes = true;
    this.genServ.obtenerPlanesdemedios(this.mymedios.mediopago).subscribe({
      next: respuestaPlanesDeMedios => {
        this.cargandoPlanes = false;
        this.planesDePagoEnPantalla = [];
        if (respuestaPlanesDeMedios['saldo'] !== undefined) {
          this.saldoActual = respuestaPlanesDeMedios['saldo'];
          this.conSaldo = true;
          this.beneficiosTrue = true;
        }
        const planes: PagosMMaxPlanes[] = respuestaPlanesDeMedios['planes'];
        let mpActivado = false;

        if (planes !== undefined) {
          planes.forEach(
            (planDePago: PagosMMaxPlanes) => {
              // console.log('activarMediodepago', planDePago)
              //idcheckout solo llega en el medio de MercadoPago, en los otros no llega
              if (planDePago.idcheckout !== undefined && planDePago.idcheckout !== "") {
                // console.log('activarmediodepago mp', planDePago.idcheckout)
                this.activarMercadoPago(planDePago.idcheckout);
                mpActivado = true;
              }
              this.planesDePagoEnPantalla.push(
                {
                  cuotas: planDePago?.cuotas,
                  montoCuota: planDePago?.montoCuota,
                  nombre: planDePago?.nombre,
                  plan: planDePago?.plan,
                  id: this.genServ.generarid(5),
                  seleccionado: false,
                }
              )
              // console.log('activar medio planesDePAgoEnpantalla',this.planesDePagoEnPantalla)
            }
          );

          // Si es Mercado Pago pero no se activó (no llegó idcheckout o llegó vacío)
          if (this.mymedios.nombre.toLowerCase().includes('mercado pago') && !mpActivado) {
            console.error('DEBUG: activarMediodepago -> Mercado Pago detected but no idcheckout received');
            this.serv.abrirMensaje('Atención', 'No se ha podido procesar el pago');
          }

          if (this.planesDePagoEnPantalla[0] != undefined) {
            this.planesDePagoEnPantalla[0].seleccionado = true;
          }
          this.myPlan = this.planesDePagoEnPantalla[0];
          if (this.myPlan != undefined) {
            this.myPlan.seleccionado = true;
            localStorage.setItem('mp_last_plan', JSON.stringify(this.myPlan));
          }
        }
        //console.log('planes de pago', this.planesDePagoEnPantalla)
      },
      error: err => {
        this.cargandoPlanes = false;
        console.error('DEBUG: activarMediodepago -> Error en obtenerPlanesdemedios:', err);
        this.serv.abrirMensaje('Error', 'No se ha podido procesar el pago');
      }
    });

  }

  activarMercadoPago(idcheckoutMercadoPago: string) {
    this.habilitarBack();
    this.publicKeyMP = this.genServ.getPublicKeyMP();
    this.idcheckoutMercadoPago = idcheckoutMercadoPago;
    this.mercadoP = true;
    this.displayPago = false;
    this.displayMP = true;
    this.iniciarPollingPago();
  }

  activarPlan(plan: PagosMMaxPlanes) {
    this.planesDePagoEnPantalla.forEach(k => {

      if (plan != k) {
        k.seleccionado = false;
      }
    })
    plan.seleccionado = true;
    this.myPlan = plan;
    localStorage.setItem('mp_last_plan', JSON.stringify(plan));

  }

  pagarYcontinuar() {
    this.finalizarCompra();
  }
  get ocultarPrecios() {
    return this.genServ.isOcultarPrecio()
  }
}

//mercadopago checkout pro integration, ver doc https://www.mercadopago.com.ar/developers/es/docs/checkout-pro/integrate-checkout-pro/web
declare var MercadoPago: any;

interface PagosMMaxPlanes {
  cuotas: number,
  montoCuota: number,
  nombre: string,
  plan: number,
  id?: string,
  seleccionado?: boolean,
  idcheckout?: string,
}
